module.exports = __webpack_public_path__ + "static/media/nc.53de550e.webp";